import {PlSentStatus} from "../device";

export enum AssetField {
    ID = "id",
    LEOID = "leoId",
    GLOBAL_ID = "globalId",
    CUSTOMER_NUMBER = "customerNumber",
    COMPANY_NAME = "companyName",
    EXTERNAL_REFERENCE = "externalReference",
    ICCID = "iccid",
    TYPE = "type",
    CONNECTION_TYPE = "connectionType",
    STATUS = "status",
    CREATED_AT = "createdAt",
    UPDATED_AT = "updatedAt",
    ORGANIZATION_ID = "organizationId",
    ORGANIZATION_NAME = "organizationName",
    PREDECESSOR_LEO_ID = "predecessorLeoId",
    PL_SENT_ID = "plSentId",
    PL_SENT_STATUS = "plSentStatus",
}

export enum AssetType {
    EETS = "EETS",
    DSX3 = "DSX3",
    KPN = "KPN",
    CO3 = "CO3",
    UNKNOWN = "UNKNOWN",
}

export enum AssetStatus {
    ACTIVE = "ACTIVE",
    INACTIVE = "INACTIVE",
    TERMINATED = "TERMINATED",
    UNKNOWN = "UNKNOWN",
}

export enum ExternalReference {
    SERIALNUMBER = "Serial Number",
    OBU_ID = "OBU ID",
    VIN = "VIN",
}

export interface Asset {
    [AssetField.ID]: number;
    [AssetField.LEOID]: string;
    [AssetField.GLOBAL_ID]: number;
    [AssetField.CUSTOMER_NUMBER]: string;
    [AssetField.COMPANY_NAME]: string;
    [AssetField.EXTERNAL_REFERENCE]: string;
    [AssetField.ICCID]: string;
    [AssetField.TYPE]: AssetType;
    [AssetField.CONNECTION_TYPE]: string;
    [AssetField.STATUS]: AssetStatus;
    [AssetField.CREATED_AT]: string;
    [AssetField.UPDATED_AT]: string;
    [AssetField.ORGANIZATION_ID]: number;
    [AssetField.ORGANIZATION_NAME]: string;
    [AssetField.PREDECESSOR_LEO_ID]: string;
    [AssetField.PL_SENT_ID]: string;
    [AssetField.PL_SENT_STATUS]: PlSentStatus;
}
